export default __webpack_public_path__ + "static/media/1894.57faaaae.png";